import React from "react";
import styles from "./introgame.module.css";
import HeaderGame from "./HeaderGame";
function IntroGame({ id, icon, children, headname }) {
  return (
      <div className={styles.main}>
        <div className={styles.body}>
          <HeaderGame gameNameTH={headname} />
          <div className={styles.picgroup}>
            <div className={styles.pic}>{icon}</div>
          </div>
          <br />
          {children}
        </div>
      </div>
  );
}

export default IntroGame;
